/* eslint-disable import/no-extraneous-dependencies */
import { Slider } from '@miblanchard/react-native-slider';
import React from 'react';
import { IconSvg } from 'src/assets';
import { Container, RegularText, Row } from 'src/components';
import { AppColors, CustomShadow } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

// const width = device.width - pixelScaler(84);

// const itemWidth = width / 5;

export const CustomSlider = ({ label }: { label: string }) => {
  const [val, setVal] = React.useState<number>(0);

  return (
    <Container marginBottom={metrics.medium}>
      <RegularText fontWeight="bold">{label}</RegularText>

      <Container>
        <Slider
          renderThumbComponent={() => {
            return (
              <Container style={{ borderRadius: 30, ...CustomShadow }}>
                {val === 0 && <IconSvg.Rate.Default />}
                {val === 1 && <IconSvg.Rate.SmallRate1 />}
                {val === 2 && <IconSvg.Rate.SmallRate2 />}
                {val === 3 && <IconSvg.Rate.SmallRate3 />}
                {val === 4 && <IconSvg.Rate.SmallRate4 />}
                {val === 5 && <IconSvg.Rate.SmallRate5 />}
              </Container>
            );
          }}
          maximumTrackTintColor="#F3F4F6"
          minimumTrackTintColor={AppColors.rateColor[val] as string}
          trackStyle={{
            height: pixelScaler(10),
          }}
          minimumValue={0}
          maximumValue={5}
          step={1}
          value={val}
          onValueChange={(value: any) => {
            console.log({ value });
            setVal(value[0]);
          }}
        />
        <Row
          pointerEvents="none"
          style={{ width: '100%', position: 'absolute', left: 0, top: 15, justifyContent: 'space-between' }}>
          <Container />
          <Container
            height={10}
            style={{
              borderColor: val === 1 ? 'transparent' : AppColors.rateSeparateColor[val >= 1 ? val : 0],
              borderWidth: 2,
            }}
          />
          <Container
            height={10}
            style={{
              borderColor: val === 2 ? 'transparent' : AppColors.rateSeparateColor[val >= 2 ? val : 0],
              borderWidth: 2,
            }}
          />
          <Container
            height={10}
            style={{
              borderColor: val === 3 ? 'transparent' : AppColors.rateSeparateColor[val >= 3 ? val : 0],
              borderWidth: 2,
            }}
          />
          <Container
            height={10}
            style={{
              borderColor: val === 4 ? 'transparent' : AppColors.rateSeparateColor[val >= 4 ? val : 0],
              borderWidth: 2,
            }}
          />
          <Container
            height={10}
            style={{
              borderColor: val === 5 ? 'transparent' : AppColors.rateSeparateColor[val >= 5 ? val : 0],
              borderWidth: 2,
            }}
          />
        </Row>
      </Container>
    </Container>
  );
};

// const Spliter1 = () => {
//   return (
//     <Row
//       style={{
//         position: 'absolute',
//         left: 0,
//         bottom: 0,
//       }}>
//       <IconSvg.Slider.Slider1 />
//       <Container
//         style={{
//           position: 'absolute',
//           right: 0,
//           bottom: 0,
//           width: pixelScaler(3),
//           height: '100%',
//           backgroundColor: AppColors.lightGray2,
//         }}
//       />
//     </Row>
//   );
// };

// const Spliter = ({
//   isDisplay,
//   value,
//   backgroundColor = AppColors.lightGray2,
// }: {
//   value?: number;
//   backgroundColor?: string;
//   isDisplay: boolean;
// }) => {
//   if (isDisplay) {
//     return (
//       <Row
//         style={{
//           position: 'absolute',
//           left: 0,
//           bottom: 0,
//         }}>
//         <IconSvg.Slider.Slider5 width={width} />
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(6),
//             backgroundColor,
//           }}
//         />
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth * 2,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(7),
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth * 3,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(9),
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth * 4,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(10),
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//         <Container
//           style={{
//             position: 'absolute',
//             right: 0,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: '100%',
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//       </Row>
//     );
//   }
//   return (
//     <Row
//       style={{
//         position: 'absolute',
//         left: 0,
//         bottom: 0,
//       }}>
//       <IconSvg.Slider.Slider5 width={width} />
//       {value === 0 && (
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(6),
//             backgroundColor,
//           }}
//         />
//       )}
//       {value === 1 && (
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth * 2,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(7),
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//       )}
//       {value === 2 && (
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth * 3,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(9),
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//       )}
//       {value === 3 && (
//         <Container
//           style={{
//             position: 'absolute',
//             left: itemWidth * 4,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: pixelScaler(10),
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//       )}
//       {value === 4 && (
//         <Container
//           style={{
//             position: 'absolute',
//             right: 0,
//             bottom: 0,
//             width: pixelScaler(3),
//             height: '100%',
//             backgroundColor: AppColors.lightGray2,
//           }}
//         />
//       )}
//     </Row>
//   );
// };
